import { render, staticRenderFns } from "./BotOnePlatformDetail.vue?vue&type=template&id=7a49b68a&"
import script from "./BotOnePlatformDetail.vue?vue&type=script&lang=js&"
export * from "./BotOnePlatformDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports